module.exports = __webpack_public_path__ + "media/images/freshdesk-d825206e47fadf7dec0cd0d608aa3097.svg";